import { useLocation, Navigate } from "react-router-dom";

const Home = () => {
  let location = useLocation();

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default Home;
